var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"erro-atendimento"},[_c('v-alert',{attrs:{"prominent":"","outlined":"","type":"error","value":true,"text":"","icon":""}},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }